import { render, staticRenderFns } from "./PDisplayStatus.vue?vue&type=template&id=4a7809fe"
import script from "./PDisplayStatus.vue?vue&type=script&lang=js"
export * from "./PDisplayStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports